export const FlowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M480-65.07q-67.15 0-114.33-47.17-47.17-47.17-47.17-114.33 0-56.29 34-99.46 34-43.17 86-56.81v-67.66H303.11q-34.48 0-58.74-24.26-24.26-24.26-24.26-58.74v-38.43h-66.5q-17.45 0-29.48-12.03-12.02-12.02-12.02-29.47v-216q0-17.46 12.02-29.48 12.03-12.02 29.48-12.02h216q17.45 0 29.47 12.02 12.03 12.02 12.03 29.48v216q0 17.45-12.03 29.47-12.02 12.03-29.47 12.03h-66.5v38.43h365.78v-44.11q-52-13.19-86-56.36t-34-99.46q0-67.16 47.18-114.33 47.17-47.17 114.32-47.17 67.15 0 114.33 47.17 47.17 47.17 47.17 114.33 0 56.29-34 99.46-34 43.17-86 56.36v44.11q0 34.48-24.26 58.74-24.26 24.26-58.74 24.26H521.5v68.11q52 13.19 86 56.36t34 99.46q0 67.16-47.17 114.33Q547.15-65.07 480-65.07Zm230.53-589.86q32.71 0 55.54-22.97 22.82-22.97 22.82-55.68 0-32.7-22.97-55.53-22.96-22.82-55.67-22.82t-55.53 22.96q-22.83 22.97-22.83 55.68 0 32.7 22.97 55.53t55.67 22.83Zm-515.42 0h133v-133h-133v133Zm285.03 506.86q32.71 0 55.53-22.96Q558.5-194 558.5-226.71q0-32.7-22.97-55.53t-55.67-22.83q-32.71 0-55.53 22.97-22.83 22.97-22.83 55.68 0 32.7 22.97 55.53 22.97 22.82 55.67 22.82ZM261.61-721.43Zm448.78-12ZM480-226.57Z" />
  </svg>
);

export const LocationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M480-119q-13 0-24.5-4.5T433-137q-40-35-86.5-82T260-320q-40-54-66-112.5T168-549q0-134 89-224.5T480-864q133 0 222.5 90.5T792-549q0 58-26.5 117t-66 113q-39.5 54-86 100.5T527-137q-11 9-22.5 13.5T480-119Zm0-361q30 0 51-21t21-51q0-30-21-51t-51-21q-30 0-51 21t-21 51q0 30 21 51t51 21Z" />
  </svg>
);

export const FilesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M263.72-96Q234-96 213-117.15T192-168v-624q0-29.7 21.15-50.85Q234.3-864 264-864h312l192 192v504q0 29.7-21.16 50.85Q725.68-96 695.96-96H263.72Zm.28-72h432v-456H528v-168H264v624Zm203.54-24q65.52 0 110.99-45.5T624-348v-132h-72v132q0 34.65-24.5 59.33Q503-264 467.51-264q-34.45 0-58.98-24.67Q384-313.35 384-348v-180q0-10 7.2-17t16.8-7q10 0 17 7t7 17v192h72v-192q0-40.32-27.77-68.16-27.78-27.84-68-27.84Q368-624 340-596.16q-28 27.84-28 68.16v180q0 65 45.5 110.5T467.54-192ZM264-792v189-189 624-624Z" />
  </svg>
);

export const RemoveIcon = (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.83337 15.5C2.37504 15.5 1.98268 15.3368 1.65629 15.0104C1.3299 14.684 1.16671 14.2917 1.16671 13.8333V3H0.333374V1.33333H4.50004V0.5H9.50004V1.33333H13.6667V3H12.8334V13.8333C12.8334 14.2917 12.6702 14.684 12.3438 15.0104C12.0174 15.3368 11.625 15.5 11.1667 15.5H2.83337ZM11.1667 3H2.83337V13.8333H11.1667V3ZM4.50004 12.1667H6.16671V4.66667H4.50004V12.1667ZM7.83337 12.1667H9.50004V4.66667H7.83337V12.1667Z"
      fill="currentColor"
    />
  </svg>
);

export default FlowIcon;
